export const formatCPF = (value) => {
  const string = value.replace(/\D/g, '').slice(0, 11);

  let formatted = string.replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');

  if (value.endsWith('.') && [3, 6].includes(string.length)) {
    formatted = formatted + '.';
  } else if (value.endsWith('-') && string.length === 9) {
    formatted = formatted + '-';
  }

  return formatted;
};
